import React from 'react';
import { QuizOption as QuizOptionType } from '../types/quiz';

interface QuizOptionProps {
  option: QuizOptionType;
  isSelected: boolean;
  showAnswer: boolean;
  // eslint-disable-next-line no-unused-vars
  onSelect: (optionId: string) => void;
}

export const QuizOption: React.FC<QuizOptionProps> = ({
  option,
  isSelected,
  showAnswer,
  onSelect,
}) => {
  const getClassName = () => {
    let baseClass = 'quiz-option';

    if (showAnswer) {
      if (option.isCorrect) {
        baseClass += ' quiz-option-correct';
      } else if (isSelected && !option.isCorrect) {
        baseClass += ' quiz-option-incorrect';
      }
    } else if (isSelected) {
      baseClass += ' border-primary-500 bg-primary-100';
    }

    return baseClass;
  };

  const getIcon = () => {
    if (!showAnswer) return null;

    if (option.isCorrect) {
      return <span className="text-2xl">✅</span>;
    } else if (isSelected) {
      return <span className="text-2xl">❌</span>;
    }
    return null;
  };

  return (
    <button
      onClick={() => !showAnswer && onSelect(option.id)}
      disabled={showAnswer}
      className={getClassName()}
    >
      <div className="flex items-center justify-between">
        <span className="text-left flex-1">{option.text}</span>
        {getIcon()}
      </div>
    </button>
  );
};
